// extracted by mini-css-extract-plugin
export default {"wrapper":"pagetitle_wrapper__wCj55","title":"pagetitle_title__BTkZK","footer":"pagetitle_footer__W4fjB"};